/**
 * Search functions
 *
 * Handles toggling the the position of the search containers
 */
(function ($) {
    'use strict';

    var $templateStateSelector = $('.t-navigation-overlay-state');
    var $SearchFormBtn = $('.m-search-form .a-btn--search');
    var $inputSearch = $('.a-input--search');

    // Toggling the search form in mobile view
    $('.js-search-mobile-toggle').on('keyup', function () {
        if (!this.value) {
            $SearchFormBtn.removeClass('a-btn--icon-right');
            return;
        }

        $SearchFormBtn.addClass('a-btn--icon-right');
    });

    /**
     * Function toggling the search form in Desktop View
     * If Sub Menu is open, close it and show Search Form
     * If Sub Menu is closed, just show Search Form
     */
    $('.js-search-desktop-toggle').on('click', function () {
        if (!$('.m-search-container--active').length || $(this).hasClass('a-close')) {
            $inputSearch.removeClass('a-input--highlight');

            if ($('.m-navigation__menu-item--has-children-desktop--open').length) {
                $('.m-navigation__menu-item--has-children').removeClass('m-navigation__menu-item--has-children-desktop--open');
            } else {
                $templateStateSelector.toggleClass('t-navigation-overlay-state-desktop--open');
            }

            $('.m-search-container').toggleClass('m-search-container--active');
            return false;
        }

        if (!$('.m-search-container--active').length || $(this).hasClass('a-link--search-link')) {
            if ($inputSearch.val()) {
                $('.m-search-form').submit();
                return;
            }

            $inputSearch.toggleClass('a-input--highlight').focus();

            return false;
        }
    });

    $('.m-search-form').on('submit', function () {
        // if there is no search input by the user do nothing

        if (!$inputSearch.val()) {
            $SearchFormBtn.addClass('a-btn--icon-right');
            $inputSearch.focus();
            return false;
        }
    });
})(jQuery); // This allows us to use '$' in place of 'jQuery' in our code. This is required especially for Wordpress.
